import { useModal } from "hooks/useModal"
import { useAppDispatch } from "reducers/store"

import styled from "styled-components"
import { useCallback, memo } from "react"
import { setAccount } from "reducers/accounts/accounts-actions"
import Tooltip from "components/Tooltip"
import IconAccountDetails from "components/EvtKit/icons/IconAccountDetails"

const InlineButton = styled.div`
  width: 25px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 16px;

  svg {
    width: 25px;
    height: 24px;
  }

  &.disabled {
    cursor: not-allowed;
  }
`

interface AccountDetailsButtonProps {
  account: App.Account
}

const AccountDetailsButton = (props: AccountDetailsButtonProps) => {
  const { account } = props

  const appDispatch = useAppDispatch()

  const { openModal } = useModal()

  const handleOnClick = useCallback(async () => {
    openModal("accountDetails")
    appDispatch(setAccount(account))
  }, [account])

  return (
    <Tooltip text="Detalhes da conta" toolTipClassName="align-right position-absolute">
      <InlineButton onClick={handleOnClick}>
        <IconAccountDetails />
      </InlineButton>
    </Tooltip>
  )
}

export default memo(AccountDetailsButton)
